/**
 * @generated SignedSource<<1bea52058c65965280e667d93731c507>>
 * @relayHash e0424719155ec546121f256079f01fd9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a05f556780430a9c3e9c36d02e6fcc5b4a00cb66378101a7ba963d0351ba14e5

import type { ConcreteRequest } from 'relay-runtime';
export type ConfluencePopularLabelStyle = "HEATMAP" | "LIST" | "%future added value";
export type usePopularLabelsDataQuery$variables = {
  cloudId: string;
  first?: number | null;
  spaceId?: string | null;
  style?: ConfluencePopularLabelStyle | null;
};
export type usePopularLabelsDataQuery$data = {
  readonly confluence_popularLabelsMacro: {
    readonly nodes: ReadonlyArray<{
      readonly labelId: string | null;
      readonly name: string | null;
      readonly rank: number | null;
    } | null> | null;
  } | null;
};
export type usePopularLabelsDataQuery = {
  response: usePopularLabelsDataQuery$data;
  variables: usePopularLabelsDataQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "first"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "style"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      },
      {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
      },
      {
        "kind": "Variable",
        "name": "spaceId",
        "variableName": "spaceId"
      },
      {
        "kind": "Variable",
        "name": "style",
        "variableName": "style"
      }
    ],
    "concreteType": "ConfluencePopularLabelEntryConnection",
    "kind": "LinkedField",
    "name": "confluence_popularLabelsMacro",
    "plural": false,
    "selections": [
      {
        "concreteType": "ConfluencePopularLabelEntry",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "name"
          },
          {
            "kind": "ScalarField",
            "name": "rank"
          },
          {
            "kind": "ScalarField",
            "name": "labelId"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "usePopularLabelsDataQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "usePopularLabelsDataQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "e0424719155ec546121f256079f01fd9",
    "id": "a05f556780430a9c3e9c36d02e6fcc5b4a00cb66378101a7ba963d0351ba14e5",
    "metadata": {},
    "name": "usePopularLabelsDataQuery",
    "operationKind": "query",
    "text": "query usePopularLabelsDataQuery($cloudId:ID!,$first:Int,$spaceId:ID,$style:ConfluencePopularLabelStyle){confluence_popularLabelsMacro(cloudId:$cloudId,first:$first,spaceId:$spaceId,style:$style){nodes{name,rank,labelId}}}"
  }
};
})();

(node as any).hash = "a1e70e0ea0c7fdc30bd20e4d9ca0b0e8";

export default node;
